import React, { useEffect, useState } from "react";
import { Image, useMediaQuery, Box, Flex, Text } from "@chakra-ui/react";
import Header from "./AuthLayout/Header";
import SideBar from "./AuthLayout/SideBar";
import { useLocation } from "react-router-dom";

export const AuthLayout = ({ children }) => {
  const [isMobile] = useMediaQuery("(max-width: 991px)");

  return (
    <Box
      color="#000"
      className="no_scroller"
      overflow="hidden"
      bg="#fff"
      fontFamily="Open Sans"
      h="100vh"
    >
      <Box overflowX="hidden">
        {!isMobile && <SideBar />}
        <Box h="2.3rem" w="full" zIndex={55} pos="fixed" top="0">
          <Box pl={!isMobile ? "310px" : "0"}>
            <Header />
          </Box>
        </Box>
        <Box overflow="auto" className="no_scroller">
          <Box
            w="100%"
            pt={isMobile ? "150px" : "125px"}
            color="#828282"
            // maxHeight="92vh"
            pl={!isMobile ? "330px" : "20px"}
            pr={!isMobile ? "32px" : "20px"}
            pb={10}
            h="100vh"
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export const NonAuthLayout = ({ children }) => {
  const { pathname } = useLocation();

  const [img, setImg] = useState("");
  const [direction, setDirection] = useState("row");

  useEffect(() => {
    switch (true) {
      case pathname.includes("login"):
        return (setImg("/assets/login.png"), setDirection("row"));

      case pathname.includes("forgot"):
        return (
          setImg("/assets/forgot-password.png"),
          setDirection("row-reverse")
        );

      case pathname.includes("update") || pathname.includes("create"):
        return (
          setImg("/assets/update-password.png"),
          setDirection("row-reverse")
        );

      default:
        return setImg("");
    }
  }, [pathname]);

  return (
    <Flex
      fontFamily="Open Sans"
      justifyContent="space-between"
      bg="#F1F8FB"
      minH="100vh"
      gap="100px"
      flexDir={direction}
      pb="10px"
    >
      <Flex
        flexDir="column"
        justifyContent={{ base: "flex-start", lg: "center" }}
        bg="#fff"
        borderRightRadius={{
          base: "none",
          lg: direction === "row" ? "100px" : "none",
        }}
        borderLeftRadius={{
          base: "none",
          lg: direction !== "row" ? "100px" : "none",
        }}
        h="100vh"
        px={{ base: "20px", lg: "50px" }}
        w={{ base: "100%", lg: "45%" }}
      >
        {children}
      </Flex>

      <Flex
        flexDir={direction !== "row" ? "column-reverse" : "column"}
        pt={{ md: "50px", "2xl": "100px" }}
        gap={{ md: "50px", "2xl": "40px" }}
        align="center"
        justifyContent="center"
        pos="relative"
        h="100vh"
        display={{ base: "none", lg: "flex" }}
        w={{ base: "100%", lg: "55%" }}
      >
        <Image
          src="/assets/logo.png"
          w={{ md: "300px", "2xl": "366px" }}
          h={{ md: "90px", "2xl": "130px" }}
        />
        <Image
          src={img}
          w={{
            md: "400px",
            "2xl": pathname.includes("update")
              ? "600px"
              : pathname.includes("forgot")
                ? "578px"
                : "555px",
          }}
          h={{
            md: "300px",
            "2xl": pathname.includes("update")
              ? "600px"
              : pathname.includes("forgot")
                ? "574px"
                : "480px",
          }}
        />
      </Flex>
    </Flex>
  );
};
